<template>
  <v-app-bar fixed app dense color="primary" flat>
    <v-toolbar-title class="white--text font-weight-bold">
      IOT Updater
    </v-toolbar-title>
    <v-spacer></v-spacer>
    <v-btn class="mr-2" dark text to="/">
      Home
    </v-btn>
    <v-btn class="mr-2" dark text to="/docs">
      Docs
    </v-btn>
    <v-menu open-on-hover bottom offset-y>
      <template v-slot:activator="{ on }">
        <v-btn class="mr-2" dark icon v-on="on">
          <v-icon>mdi-translate</v-icon>
        </v-btn>
      </template>
      <v-list>
        <v-list-item
          v-for="(item, index) in locales"
          :key="index"
          @click="setLocale(item.locale)"
        >
          <v-list-item-title>{{ item.title }}</v-list-item-title>
        </v-list-item>
      </v-list>
    </v-menu>
    <intro-modal />
  </v-app-bar>
</template>

<script>
import introModal from "./introModal.vue";

export default {
  components: {
    introModal,
  },

  data() {
    return {
      locales: [
        { locale: "en", title: "English" },
        { locale: "es", title: "Español" },
      ],
    };
  },
  methods: {
    darkMode() {
      this.$vuetify.theme.dark = !this.$vuetify.theme.dark;
    },
    setLocale(locale) {
      this.$i18n.locale = locale;
      localStorage.setItem("locale", locale);
      window.location.reload();
    },
  },
};
</script>
